const part = [
    {
        path: 'suggestion-management-list',
        name: 'suggestion-management-list',
        meta: {
            icon: 'md-people',
            title: '投诉建议管理',
            notCache: true,
            access: ['S'],
            items: [
            ]
        },
        component: () => import('@/view/system-management/suggestion-management/suggestion-list')
    }
];

export default part;
